import * as React from 'react';
import { Button } from '@material-ui/core';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({ open, onDeletePress, handleClose, deleteThis, message, confirmText }) {

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message || `Are you sure you want to delete this ${deleteThis}?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{justifyContent : "center"}}>
                    <Button onClick={handleClose} variant="contained" className="m-1" color="primary">Cancel</Button>
                    <Button onClick={onDeletePress} variant="contained" className="m-1" color="secondary">{confirmText || "Confirm Delete"}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
